module.exports = __webpack_public_path__ + "static/carnival-logo-be22d601b95a5d73ee6d2026a7d166aa.png";